// Module
var code = "<user-notifications is-mobile=\"true\"></user-notifications> ";
// Exports
export default code;